const branches = {
  development: 'development',
  staging: 'staging',
  master: 'production',
  main: 'production',
};

const suffixes = {
  development: '_DEVELOPMENT',
  staging: '_STAGING',
  production: '_PRODUCTION',
};

const gitBranch = process.env.VUE_APP_VERCEL_GIT_COMMIT_REF;
if (!gitBranch) throw new Error('Environment not defined');

const environment = branches[gitBranch] || 'development';

const suffix = suffixes[environment];

const getEnvironmentVariable = (variable) => process.env[`${variable}${suffix}`];

export default getEnvironmentVariable;
